/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { DashboardDTO } from '../model/models';
import { DashboardFilter } from '../model/models';
import { DashboardTrendDTO } from '../model/models';
import { DashboardTrendFilter } from '../model/models';
import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface GetDashboardSnapshotRequestParams {
    filter: DashboardFilter;
}

export interface GetDashboardTrendRequestParams {
    filter: DashboardTrendFilter;
}


export interface CruscottoDirezionaleServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Snapshot d\&#39;insieme del cruscotto direzionale: quattro tessere cross-dominio (pratiche+funnel, denaro+voucher, mensa, esercenti) comune-wide, un comune alla volta via ?comune_id (filtro dentro lo scope: out-of-scope → 403). Scope per-authority: SUPERADMIN tutti i comuni, ADMIN/OP_COMUNE i propri comuniGestiti. Importi BigDecimal scala 2, mai null.
     * 
     * @endpoint get /api/v1/gestione/dashboard
* @param requestParameters
     */
    getDashboardSnapshot(requestParameters: GetDashboardSnapshotRequestParams, extraHttpRequestParams?: any): Observable<DashboardDTO>;

    /**
     * Serie temporali del cruscotto (dall\&#39;audit log): domande per periodo, funnel di conversione, tempo medio di risposta al cittadino (submit→primo esito, media solo sulle evase; le in-attesa riportate a parte), voucher e incassi mensa per mese. Parametri ?da&amp;a (YYYY-MM) e ?granularita (mese|settimana); bucketing in Europe/Rome. Intervallo/granularità invalidi → 400.
     * 
     * @endpoint get /api/v1/gestione/dashboard/trend
* @param requestParameters
     */
    getDashboardTrend(requestParameters: GetDashboardTrendRequestParams, extraHttpRequestParams?: any): Observable<DashboardTrendDTO>;

}
